import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';

const types = {
    SAVE_PARTNER_OFFERS_FILTERS: 'SAVE_PARTNER_OFFERS_FILTERS',
    SAVE_PARTNER_SPLITTERS_FILTERS: 'SAVE_PARTNER_SPLITTERS_FILTERS',
    RESET_PARTNER_OFFERS_FILTERS: 'RESET_PARTNER_OFFERS_FILTERS',
    RESET_PARTNER_SPLITTERS_FILTERS: 'RESET_PARTNER_SPLITTERS_FILTERS',
};

const initialState = {
    offers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    splitters: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
            advanced: 0,
        },
    },
};

const state = {
    ...initialState,
};


const getters = {
    partnerOffersFilters: state => state.offers.filters,
    partnerSplittersFilters: state => state.splitters.filters,
};


const actions = {
    savePartnerOffersFilters ({ commit }, payload) {
        commit(types.SAVE_PARTNER_OFFERS_FILTERS, { payload });
    },
    resetPartnerOffersFilters ({ commit }) {
        commit(types.RESET_PARTNER_OFFERS_FILTERS);
    },
    resetPartnerSplittersFilters ({ commit }) {
        commit(types.RESET_PARTNER_SPLITTERS_FILTERS);
    },
    savePartnerSplittersFilters ({ commit }, payload) {
        commit(types.SAVE_PARTNER_SPLITTERS_FILTERS, { payload });
    },
};


const mutations = {
    [types.SAVE_PARTNER_OFFERS_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.offers = {
            ...state.offers,
            filters: { ...payloadNormalized },
        };
    },
    [types.SAVE_PARTNER_SPLITTERS_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.splitters = {
            ...state.splitters,
            filters: { ...payloadNormalized },
        };
    },
    [types.RESET_PARTNER_OFFERS_FILTERS] (state) {
        state.offers.filters = { ...initialState.offers.filters };
    },
    [types.RESET_PARTNER_SPLITTERS_FILTERS] (state) {
        state.splitters.filters = { ...initialState.splitters.filters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
